"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  NavigationButtonLeft: ['navigation-button-left', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M0.751 5.997 L12.751 5.997 L12.751 17.997 L0.751 17.997 Z', 'M17.251 11.997L23.251 11.997', 'M21.001 14.247L23.251 11.997 21.001 9.747', 'M9.751 11.997L3.751 11.997', 'M6.001 14.247L3.751 11.997 6.001 9.747']],
  NavigationArrowsRight: ['navigation-arrows-right', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M.751,1.5a.75.75,0,0,1,1.3-.511l8.8,9.987a1.5,1.5,0,0,1,0,2.047l-8.8,9.986a.75.75,0,0,1-1.3-.512Z', 'M6.751,17.671V22.5a.75.75,0,0,0,1.3.512l8.8-9.986a1.5,1.5,0,0,0,0-2.047L8.049.987a.75.75,0,0,0-1.3.511V6.324', 'M12.751,17.671V22.5a.75.75,0,0,0,1.3.512l8.8-9.986a1.5,1.5,0,0,0,0-2.047L14.049.987a.75.75,0,0,0-1.3.511V6.324']],
  NavigationArrowsDown1: ['navigation-arrows-down-1', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M10.858,14.468a1.5,1.5,0,0,0,2.285,0l9.75-11.25A1.5,1.5,0,0,0,21.751.747H2.251A1.5,1.5,0,0,0,1.108,3.218Z', 'M3,9H2.251a1.5,1.5,0,0,0-1.143,2.471l9.75,11.25a1.5,1.5,0,0,0,2.285,0l9.75-11.25A1.5,1.5,0,0,0,21.751,9H21']],
  NavigationArrowsLeft: ['navigation-arrows-left', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M23.251,22.5a.75.75,0,0,1-1.3.511l-8.8-9.987a1.5,1.5,0,0,1,0-2.047l8.8-9.986a.75.75,0,0,1,1.3.511Z', 'M17.251,6.323V1.5a.75.75,0,0,0-1.3-.511l-8.8,9.986a1.5,1.5,0,0,0,0,2.047l8.8,9.987a.75.75,0,0,0,1.3-.511V17.67', 'M11.251,6.323V1.5a.75.75,0,0,0-1.3-.511l-8.8,9.986a1.5,1.5,0,0,0,0,2.047l8.8,9.987a.75.75,0,0,0,1.3-.511V17.67']],
  NavigationArrowsDown: ['navigation-arrows-down', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M1.5.747a.75.75,0,0,0-.512,1.3l9.988,8.8a1.5,1.5,0,0,0,2.047,0l9.986-8.8A.75.75,0,0,0,22.5.747Z', 'M17.674,6.747H22.5a.75.75,0,0,1,.512,1.3l-9.986,8.8a1.5,1.5,0,0,1-2.047,0L.99,8.045a.75.75,0,0,1,.512-1.3H6.328', 'M17.674,12.747H22.5a.75.75,0,0,1,.512,1.3l-9.986,8.8a1.5,1.5,0,0,1-2.047,0L.99,14.045a.75.75,0,0,1,.512-1.3H6.328']],
  NavigationArrowsRight1: ['navigation-arrows-right-1', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M14.472,13.14a1.5,1.5,0,0,0,0-2.286L3.222,1.1A1.5,1.5,0,0,0,.751,2.247v19.5A1.5,1.5,0,0,0,3.222,22.89Z', 'M9,21v.749a1.5,1.5,0,0,0,2.471,1.143l11.25-9.75a1.5,1.5,0,0,0,0-2.286L11.472,1.1A1.5,1.5,0,0,0,9,2.247V3']],
  NavigationArrowsUp: ['navigation-arrows-up', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M1.5,23.247a.75.75,0,0,1-.511-1.3l9.987-8.8a1.5,1.5,0,0,1,2.047,0l9.986,8.8a.75.75,0,0,1-.512,1.3Z', 'M17.672,17.247H22.5a.75.75,0,0,0,.512-1.3l-9.986-8.8a1.5,1.5,0,0,0-2.047,0l-9.987,8.8a.75.75,0,0,0,.511,1.3H6.325', 'M17.671,11.247H22.5a.75.75,0,0,0,.512-1.3l-9.986-8.8a1.5,1.5,0,0,0-2.047,0L.988,9.949a.75.75,0,0,0,.511,1.3H6.325']],
  NavigationArrowsLeft1: ['navigation-arrows-left-1', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M9.529,13.14a1.5,1.5,0,0,1,0-2.286L20.779,1.1a1.5,1.5,0,0,1,2.472,1.143v19.5a1.5,1.5,0,0,1-2.472,1.143Z', 'M15,21v.75a1.5,1.5,0,0,1-2.472,1.143L1.279,13.14a1.5,1.5,0,0,1,0-2.286L12.529,1.1A1.5,1.5,0,0,1,15,2.247V3']],
  NavigationLeft4: ['navigation-left-4', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-miterlimit': '10',
    'stroke-width': '1.5'
  }], ['M15.029,14.247h6.722a1.5,1.5,0,0,1,1.5,1.5V21a1.5,1.5,0,0,1-1.5,1.5H11.691A10.792,10.792,0,0,1,.755,12.32,10.5,10.5,0,0,1,11.251,1.5h10.5a1.5,1.5,0,0,1,1.5,1.5v5.25a1.5,1.5,0,0,1-1.5,1.5H15.027', 'M15.029,14.249l.922.922A1.875,1.875,0,1,1,13.3,17.823l-4.5-4.5a1.874,1.874,0,0,1,0-2.652l4.5-4.5a1.875,1.875,0,0,1,2.651,2.652l-.924.924']],
  NavigationLeft3: ['navigation-left-3', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M0.748 11.997L18.748 11.997', 'M5.248 17.997L0.748 11.997 5.15 5.997', 'M18.748 8.247L18.748 15.747', 'M23.248 8.247L23.248 15.747']],
  NavigationLeft: ['navigation-left', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M4.415,8.662A11.969,11.969,0,0,1,23.25,18.5a7.5,7.5,0,0,0-7.5-7.5,7.414,7.414,0,0,0-5.972,3.028l3.192,3.192a.75.75,0,0,1-.531,1.28H2.25A1.5,1.5,0,0,1,.75,17V6.808a.75.75,0,0,1,1.28-.531Z']],
  NavigationDown3: ['navigation-down-3', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-miterlimit': '10',
    'stroke-width': '1.5'
  }], ['M14.251,8.969V2.247a1.5,1.5,0,0,1,1.5-1.5H21a1.5,1.5,0,0,1,1.5,1.5v10.06A10.792,10.792,0,0,1,12.324,23.242,10.5,10.5,0,0,1,1.5,12.747V2.247A1.5,1.5,0,0,1,3,.747h5.25a1.5,1.5,0,0,1,1.5,1.5V8.97', 'M14.253,8.969l.922-.923A1.875,1.875,0,1,1,17.826,10.7l-4.5,4.5a1.875,1.875,0,0,1-2.651,0l-4.5-4.5A1.875,1.875,0,0,1,8.826,8.046l.924.924']],
  NavigationLeft1: ['navigation-left-1', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M17.248,18.747v-4.5a1.5,1.5,0,0,1,1.5-1.5h4.5', 'M23.248,12.747a6,6,0,0,1-6,6h-6V22.5a.75.75,0,0,1-1.3.512l-8.8-9.988a1.5,1.5,0,0,1,0-2.047L9.95.987a.75.75,0,0,1,1.3.512V5.247h10.5a1.5,1.5,0,0,1,1.5,1.5Z']],
  NavigationDown: ['navigation-down', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M18.751,6.747h-4.5a1.5,1.5,0,0,1-1.5-1.5V.747', 'M12.751.747a6,6,0,0,1,6,6v6H22.5a.75.75,0,0,1,.511,1.3l-9.988,8.8a1.5,1.5,0,0,1-2.047,0L.99,14.045a.75.75,0,0,1,.512-1.3H5.251V2.247a1.5,1.5,0,0,1,1.5-1.5Z']],
  NavigationDown2: ['navigation-down-2', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M12.001 23.247L12.001 5.247', 'M18.001 18.747L12.001 23.247 6.001 18.845', 'M8.251 5.247L15.751 5.247', 'M8.251 0.747L15.751 0.747']],
  NavigationDown1: ['navigation-down-1', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M0.751 13.509L12.001 21.335 23.251 13.509', 'M.751,3.314c0-.538.361-.727.8-.42L11.2,9.6a1.513,1.513,0,0,0,1.607,0l9.643-6.709c.442-.307.8-.118.8.42v3.3a2.1,2.1,0,0,1-.8,1.537L12.8,14.864a1.517,1.517,0,0,1-1.607,0L1.554,8.155a2.1,2.1,0,0,1-.8-1.537Z']],
  NavigationDownCircle: ['navigation-down-circle', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M12.001 16.497L12.001 7.497', 'M15.751 12.747L12.001 16.497 8.251 12.747', 'M1.501 11.997 A10.500 10.500 0 1 0 22.501 11.997 A10.500 10.500 0 1 0 1.501 11.997 Z']],
  NavigationNext: ['navigation-next', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M23.251,9.747H12a3.75,3.75,0,0,0-3.75,3.75', 'M20.251 6.747L23.251 9.747 20.251 12.747', 'M17.251,5.247a1.5,1.5,0,0,0-1.5-1.5H2.251a1.5,1.5,0,0,0-1.5,1.5v13.5a1.5,1.5,0,0,0,1.5,1.5h13.5a1.5,1.5,0,0,0,1.5-1.5v-4.5']],
  NavigationRight1: ['navigation-right-1', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M6.748,5.249v4.5a1.5,1.5,0,0,1-1.5,1.5H.748', 'M.748,11.249a6,6,0,0,1,6-6h6V1.5a.75.75,0,0,1,1.3-.512l8.8,9.988a1.5,1.5,0,0,1,0,2.047l-8.8,9.987a.75.75,0,0,1-1.3-.512V18.749H2.248a1.5,1.5,0,0,1-1.5-1.5Z']],
  NavigationLeftCircle2: ['navigation-left-circle-2', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M0.750 11.998 A11.250 11.250 0 1 0 23.250 11.998 A11.250 11.250 0 1 0 0.750 11.998 Z', 'M10.5,15.748l-5.25-4.5,5.25-4.5V9h3A4.5,4.5,0,0,1,18,13.5v3a3,3,0,0,0-3-3H10.5Z']],
  NavigationRight4: ['navigation-right-4', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-miterlimit': '10',
    'stroke-width': '1.5'
  }], ['M8.972,9.747H2.251a1.5,1.5,0,0,1-1.5-1.5V3a1.5,1.5,0,0,1,1.5-1.5H12.31A10.792,10.792,0,0,1,23.246,11.674,10.5,10.5,0,0,1,12.751,22.5H2.251A1.5,1.5,0,0,1,.751,21v-5.25a1.5,1.5,0,0,1,1.5-1.5H8.974', 'M8.972,9.745,8.05,8.823A1.875,1.875,0,1,1,10.7,6.171l4.5,4.5a1.874,1.874,0,0,1,0,2.652l-4.5,4.5A1.875,1.875,0,0,1,8.05,15.171l.924-.924']],
  NavigationPrevious: ['navigation-previous', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M.751,9.747H12a3.75,3.75,0,0,1,3.75,3.75', 'M3.751 6.747L0.751 9.747 3.751 12.747', 'M6.751,5.247a1.5,1.5,0,0,1,1.5-1.5h13.5a1.5,1.5,0,0,1,1.5,1.5v13.5a1.5,1.5,0,0,1-1.5,1.5H8.251a1.5,1.5,0,0,1-1.5-1.5v-4.5']],
  NavigationRight2: ['navigation-right-2', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M13.513 0.747L21.339 11.997 13.513 23.247', 'M3.318.747c-.538,0-.727.361-.42.8l6.709,9.644a1.515,1.515,0,0,1,0,1.606L2.9,22.444c-.307.442-.118.8.42.8h3.3a2.105,2.105,0,0,0,1.537-.8L14.867,12.8a1.511,1.511,0,0,0,0-1.606L8.159,1.55a2.105,2.105,0,0,0-1.537-.8Z']],
  NavigationRight: ['navigation-right', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M19.585,8.662A11.969,11.969,0,0,0,.75,18.5,7.5,7.5,0,0,1,8.25,11a7.412,7.412,0,0,1,5.972,3.028L11.03,17.217a.75.75,0,0,0,.531,1.28H21.75a1.5,1.5,0,0,0,1.5-1.5V6.808a.75.75,0,0,0-1.28-.531Z']],
  NavigationRight3: ['navigation-right-3', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M23.248 11.997L5.248 11.997', 'M18.748 17.997L23.248 11.997 18.846 5.997', 'M5.248 8.247L5.248 15.747', 'M0.748 8.247L0.748 15.747']],
  NavigationRightCircle1: ['navigation-right-circle_1', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M16.501 11.997L7.501 11.997', 'M12.751 8.247L16.501 11.997 12.751 15.747', 'M1.501 11.997 A10.500 10.500 0 1 0 22.501 11.997 A10.500 10.500 0 1 0 1.501 11.997 Z']],
  NavigationUp: ['navigation-up', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M5.252,17.247h4.5a1.5,1.5,0,0,1,1.5,1.5v4.5', 'M11.252,23.247a6,6,0,0,1-6-6v-6H1.5a.75.75,0,0,1-.512-1.3l9.989-8.8a1.5,1.5,0,0,1,2.047,0l9.986,8.8a.75.75,0,0,1-.511,1.3H18.752v10.5a1.5,1.5,0,0,1-1.5,1.5Z']],
  NavigationUp1: ['navigation-up-1', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M23.251 10.573L12.001 2.747 0.751 10.573', 'M23.251,20.768c0,.538-.362.727-.8.42L12.8,14.479a1.517,1.517,0,0,0-1.607,0L1.554,21.188c-.442.307-.8.118-.8-.42v-3.3a2.1,2.1,0,0,1,.8-1.537L11.2,9.218a1.517,1.517,0,0,1,1.607,0l9.643,6.709a2.1,2.1,0,0,1,.8,1.537Z']],
  NavigationUpCircle: ['navigation-up-circle', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M12.001 7.497L12.001 16.497', 'M8.251 11.247L12.001 7.497 15.751 11.247', 'M1.501 11.997 A10.500 10.500 0 1 0 22.501 11.997 A10.500 10.500 0 1 0 1.501 11.997 Z']],
  NavigationUp3: ['navigation-up-3', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-miterlimit': '10',
    'stroke-width': '1.5'
  }], ['M9.751,15.025v6.722a1.5,1.5,0,0,1-1.5,1.5H3a1.5,1.5,0,0,1-1.5-1.5V11.687A10.791,10.791,0,0,1,11.678.752,10.5,10.5,0,0,1,22.5,11.247v10.5a1.5,1.5,0,0,1-1.5,1.5h-5.25a1.5,1.5,0,0,1-1.5-1.5V15.024', 'M9.749,15.025l-.923.923A1.875,1.875,0,0,1,6.175,13.3l4.5-4.5a1.875,1.875,0,0,1,2.651,0l4.5,4.5a1.875,1.875,0,1,1-2.651,2.652l-.924-.924']],
  NavigationUp2: ['navigation-up-2', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M12.001 0.747L12.001 18.747', 'M6.001 5.247L12.001 0.747 18.001 5.149', 'M15.751 18.747L8.251 18.747', 'M15.751 23.247L8.251 23.247']],
  NavigationRightCircle2: ['navigation-right-circle-2', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M0.750 11.998 A11.250 11.250 0 1 0 23.250 11.998 A11.250 11.250 0 1 0 0.750 11.998 Z', 'M13.5,15.748l5.25-4.5-5.25-4.5V9h-3A4.5,4.5,0,0,0,6,13.5v3a3,3,0,0,1,3-3h4.5Z']],
  NavigationButtonRight: ['navigation-button-right', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M11.251 5.997 L23.251 5.997 L23.251 17.997 L11.251 17.997 Z', 'M6.751 11.997L0.751 11.997', 'M3.001 14.247L0.751 11.997 3.001 9.747', 'M14.251 11.997L20.251 11.997', 'M18.001 14.247L20.251 11.997 18.001 9.747']],
  NavigationRightCircle: ['navigation-right-circle', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M0.750 11.997 A11.250 11.250 0 1 0 23.250 11.997 A11.250 11.250 0 1 0 0.750 11.997 Z', 'M18.75,9.747H9a3.75,3.75,0,0,0,0,7.5', 'M15.75 6.747L18.75 9.747 15.75 12.747']],
  NavigationArrowsUp1: ['navigation-arrows-up-1', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M13.141,9.526a1.5,1.5,0,0,0-2.286,0l-9.75,11.25a1.5,1.5,0,0,0,1.143,2.471h19.5a1.5,1.5,0,0,0,1.143-2.471Z', 'M21,15h.75a1.5,1.5,0,0,0,1.143-2.471l-9.75-11.25a1.5,1.5,0,0,0-2.286,0l-9.75,11.25A1.5,1.5,0,0,0,2.248,15H3']],
  NavigationLeftCircle: ['navigation-left-circle', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M0.750 11.997 A11.250 11.250 0 1 0 23.250 11.997 A11.250 11.250 0 1 0 0.750 11.997 Z', 'M5.25,9.747H15a3.75,3.75,0,0,1,0,7.5', 'M8.25 6.747L5.25 9.747 8.25 12.747']],
  NavigationLeftCircle1: ['navigation-left-circle-1', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M7.501 11.997L16.501 11.997', 'M11.251 15.747L7.501 11.997 11.251 8.247', 'M1.501 11.997 A10.500 10.500 0 1 0 22.501 11.997 A10.500 10.500 0 1 0 1.501 11.997 Z']],
  NavigationLeft2: ['navigation-left-2', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M10.577 0.747L2.751 11.997 10.577 23.247', 'M20.772.747c.538,0,.727.361.419.8l-6.708,9.644a1.511,1.511,0,0,0,0,1.606l6.708,9.644c.308.442.119.8-.419.8h-3.3a2.1,2.1,0,0,1-1.537-.8L9.222,12.8a1.515,1.515,0,0,1,0-1.606L15.931,1.55a2.1,2.1,0,0,1,1.537-.8Z']]
};
exports["default"] = _default;